module.exports = __webpack_public_path__ + "static/media/explore_03.cd425179.jpg";